import placeholder from "./res/svg/imagePlaceholder.svg";

export default class Assets {
    static imagePlaceholder = placeholder;
}
